"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrozenCartRender = exports.ExpiredCartRender = exports.EmptyCartRender = exports.FloatingCartClickDelete = exports.FloatingCartClickCheckout = exports.FloatingCartReviewCart = exports.FloatingCartRender = exports.AddToCartClick = exports.AddToCartRender = exports.SHARED_PROPS = void 0;
const getProductsBy = (key, groups) => {
    if (!groups)
        return [];
    return groups.reduce((acc, curr) => {
        const flat = curr.items.map((item) => item[key]);
        return [...acc, ...flat];
    }, []);
};
const getCampaigns = (groups) => (groups ? groups.map((group) => group.campaign_name) : []);
exports.SHARED_PROPS = {
    'Funnel Type': 'Classic',
    'Orderpipe Version': 'New',
    'Orderpipe Test Eligible': true,
};
const sharedAddToCartProps = (cart) => {
    const props = Object.assign({}, exports.SHARED_PROPS);
    if (cart.public_id)
        props['Cart ID'] = cart.public_id;
    if (cart.subtotal)
        props['Cart Value TTC'] = cart.subtotal;
    if (cart.subtotal_base)
        props['Cart Value HT'] = cart.subtotal_base;
    const lastItem = cart.last_cart_item;
    if (lastItem) {
        if (lastItem.item_name)
            props['Cart Products'] = lastItem.item_name;
        if (lastItem.product_id)
            props['Cart Product IDs'] = lastItem.product_id;
        if (lastItem.campaign_code)
            props['Cart Product Operation Code'] = lastItem.campaign_code;
    }
    return props;
};
const sharedCartProps = (cart) => {
    const props = Object.assign({}, exports.SHARED_PROPS);
    if (cart.public_id)
        props['Cart ID'] = cart.public_id;
    if (cart.subtotal)
        props['Cart Value TTC'] = cart.subtotal;
    if (cart.subtotal_base)
        props['Cart Value HT'] = cart.subtotal_base;
    if (cart.total_units)
        props['Cart Size'] = cart.total_units;
    if (cart.last_cart_item) {
        props['Cart Products'] = getProductsBy('item_name', cart.cart_item_groups);
        props['Cart Product IDs'] = getProductsBy('product_id', cart.cart_item_groups);
        props['Cart Product Operation Code'] = getCampaigns(cart.cart_item_groups);
    }
    if (cart.campaign_count) {
        props['Multisale Cart'] = cart.campaign_count > 1;
        props['# Of Operations'] = cart.campaign_count;
    }
    return props;
};
const AddToCartRender = (cart) => {
    var _a, _b;
    const props = Object.assign({ 'Interaction Type': 'Page View', 'Reopen Order': (_b = (_a = cart === null || cart === void 0 ? void 0 : cart.metadata) === null || _a === void 0 ? void 0 : _a.show_reopen) !== null && _b !== void 0 ? _b : false }, sharedAddToCartProps(cart));
    return ['Feedback Add To Cart', props];
};
exports.AddToCartRender = AddToCartRender;
const AddToCartClick = (cart) => {
    var _a, _b;
    const props = Object.assign({ 'Interaction Type': 'Click', 'Page Name': 'Feedback Add To Cart', 'Click Name': 'Floating Cart - See my Cart', 'Reopen Order': (_b = (_a = cart === null || cart === void 0 ? void 0 : cart.metadata) === null || _a === void 0 ? void 0 : _a.show_reopen) !== null && _b !== void 0 ? _b : false }, sharedAddToCartProps(cart));
    return ['Click', props];
};
exports.AddToCartClick = AddToCartClick;
const FloatingCartRender = (cart) => [
    'Open Floating Cart',
    Object.assign({ 'Interaction Type': 'Page View' }, sharedCartProps(cart)),
];
exports.FloatingCartRender = FloatingCartRender;
const FloatingCartReviewCart = (cart) => [
    'Click',
    Object.assign({ 'Interaction Type': 'Click', 'Click Name': 'Floating Cart - See my Cart', 'Page Name': 'Floating Cart' }, sharedCartProps(cart)),
];
exports.FloatingCartReviewCart = FloatingCartReviewCart;
const FloatingCartClickCheckout = (cart) => [
    'Click',
    Object.assign({ 'Interaction Type': 'Click', 'Click Name': 'Floating Cart - Place order', 'Page Name': 'Floating Cart' }, sharedCartProps(cart)),
];
exports.FloatingCartClickCheckout = FloatingCartClickCheckout;
const FloatingCartClickDelete = (item) => [
    'Click',
    Object.assign(Object.assign({}, exports.SHARED_PROPS), { 'Interaction Type': 'Click', 'Click Name': 'Cart product deleted', 'Page Name': 'Floating Cart', 'Cart Product Operation Code': item.campaign_code }),
];
exports.FloatingCartClickDelete = FloatingCartClickDelete;
const EmptyCartRender = () => [
    'Empty Cart',
    Object.assign(Object.assign({}, exports.SHARED_PROPS), { 'Interaction Type': 'Page View' }),
];
exports.EmptyCartRender = EmptyCartRender;
const ExpiredCartRender = () => [
    'Expired Cart Dialog',
    Object.assign(Object.assign({}, exports.SHARED_PROPS), { 'Interaction Type': 'Page View' }),
];
exports.ExpiredCartRender = ExpiredCartRender;
const FrozenCartRender = () => [
    'Frozen Cart Dialog',
    Object.assign(Object.assign({}, exports.SHARED_PROPS), { 'Interaction Type': 'Page View' }),
];
exports.FrozenCartRender = FrozenCartRender;
